export const COUPON_TYPE_OPTIONS = [
  { id: "active", label: "Special Offer" },
  { id: "expired", label: "Expired Coupon" },
];

export const DEFAULT_COUPON_FILTERS = {
  categoryIds: [],
  moduleIds: [],
  types: [],
};

export function parseIdList(value = "") {
  return String(value)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}

export function matchesIdFilter(itemIds, selectedIds) {
  if (!selectedIds.length) return true;
  const ids = parseIdList(itemIds);
  return selectedIds.some((id) => ids.includes(String(id)));
}

export function formatCouponExpiry(dateStr = "") {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function filterCoupons(couponData, filters = DEFAULT_COUPON_FILTERS) {
  const categoryIds = filters.categoryIds || [];
  const moduleIds = filters.moduleIds || [];
  const types = filters.types || [];

  let list = [];

  if (!types.length) {
    list = [...(couponData?.activeCoupons || [])];
  } else {
    if (types.includes("active")) {
      list = [...list, ...(couponData?.activeCoupons || [])];
    }
    if (types.includes("expired")) {
      list = [...list, ...(couponData?.expiredCoupons || [])];
    }
  }

  if (categoryIds.length) {
    list = list.filter((item) => matchesIdFilter(item.categoryId, categoryIds));
  }

  if (moduleIds.length) {
    list = list.filter((item) => matchesIdFilter(item.moduleId, moduleIds));
  }

  return list;
}

export function getCouponHeroImage(couponData) {
  const active = couponData?.activeCoupons || [];
  const withBanner = active.find((item) => item.bannerImagePath);
  return withBanner?.bannerImagePath || active[0]?.bannerImagePath || "/images/hero.png";
}

export function formatCouponExpiryShort(dateStr = "") {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function getPrimaryCategoryLabel(categoryNames = "") {
  return String(categoryNames).split(",")[0]?.trim() || "";
}

export function getCouponDetailPath(slug = "") {
  if (!slug) return "/coupons";
  return `/coupons/${slug}`;
}
